<template>
  <main id="main">
    <template v-if="$page">
      <AnchorsTimelineHeader :content="$page.header" />
      <SectionsRenderer v-if="$page.sections.length" :sections="$page.sections" />
    </template>
    <Transition name="fade">
      <Loader v-if="!$page" />
    </Transition>
  </main>
</template>

<script>
import { AnchorsTimelineHeader } from '@/components/sections'
import SectionsRenderer from '@/components/SectionsRenderer.vue'
import { Loader } from '@/components/small'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'About',
  mixins: [PageMetaMixin],
  beetPage: 'about',
  components: { AnchorsTimelineHeader, Loader, SectionsRenderer },
}
</script>
